import { render, staticRenderFns } from "./TestNote.vue?vue&type=template&id=2d6d0c3c&"
import script from "./TestNote.vue?vue&type=script&lang=js&"
export * from "./TestNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports